export default {
  intro: {
    default: 'Ingresa los datos de la persona que firma el contrato.',
    gbr: 'Ingresa los datos del socio que firma el contrato.',
    gmbh: 'Ingresa los datos del propietario o director general que firma el contrato.',
  },
  sections: {
    home_address: 'Dirección particular',
    home_address_help: 'Dónde vive esta persona, no la dirección del restaurante.',
  },
  form: {
    owner_first_name: {
      label: 'Nombre',
      placeholder: 'Ingresa el nombre',
    },
    owner_last_name: {
      label: 'Apellido',
      placeholder: 'Ingresa el apellido',
    },
    owner_dob: {
      label: 'Fecha de nacimiento',
      placeholder: 'Fecha',
    },
    owner_phone_number: {
      label: 'Teléfono',
    },
    owner_email: {
      label: 'Correo electrónico',
      placeholder: 'Ingresa el correo electrónico',
      help: 'Puede ser diferente del correo con el que inicias sesión.',
    },
    owner_id_number: {
      label: 'Número de identificación (p. ej., número de seguro social en EE. UU.)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Atrás',
    next: 'Siguiente',
  },
};
